export const DEFAULT_MAX_MESSAGE_LENGTH = 1024;